module.exports = __webpack_public_path__ + "img/5.430cfa55.svg";